import { 
    Component, 
    ChangeDetectionStrategy,
    ViewEncapsulation, 
    OnInit,
    Input,
    HostBinding,
    HostListener,
    ChangeDetectorRef
} from '@angular/core';
import { LayoutType } from '@app/shared/types/app-config.interface';
// import { ColorContrast } from '@app/shared/utils/ColorContrast';
import { NotificationService } from '@app/shared/services/notification.service';
import { Router } from '@angular/router';
// import { TimeSince } from '@app/shared/utils/TimeSince'
import { OrderService } from '@app/shared/services/order.service';
import { JssService } from '@app/shared/services/jss.service';

@Component({
    selector: 'header-nav',
    templateUrl: './header-nav.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.header-nav]': 'true',
        '[class.layout-vertical]': 'layoutType === "vertical"',
        '[class.layout-horizon]': 'layoutType === "horizontal"',
        '[class.is-collapse]': 'collapse',
        '[class.header-nav-item]': 'true',
       
    },
    providers: [
        NotificationService
    ],
})
export class HeaderNavComponent implements OnInit {

    @Input() layoutType: LayoutType
    @Input() collapse: boolean
    @Input() isMobile: boolean
    @Input()@HostBinding('style.background-color') color: string = '#ffffff'

    logoColor: 'light' | 'dark'

   

    profileMenuList = [
        {
            path: '/userProfile',
            icon: 'feather icon-user',
            item: 'Profile'
        },
       
        {
            path: '',
            icon: 'feather icon-power',
            item: 'Sign Out'
        }
    ]
  

    pendingCount: number = 0;
    confirmedCount: number = 0;
    confirmOrderId:any[]=[];
    
    previousPendingCount: number = 0;
    previousConfirmedCount: number = 0;
    
    pendingNotificationMessage: string = '';
    confirmedNotificationMessage: string = '';
    orderList: any[];
    filteredOrderList: any[];

    constructor(private cdr: ChangeDetectorRef,
        private orderService: OrderService,private router:Router,private jss: JssService) {
       
    }
    
  

   
    username:any = localStorage.getItem('username');
    email:any = localStorage.getItem('email');
  profileimg:any = localStorage.getItem('profileImg');
 
  ngOnInit(): void {
    this.getAllOrder(); // Initial call
    this.getConfirmedOrders(); // Initial call for confirmed orders
    setInterval(() => {
      this.getAllOrder();
      this.getConfirmedOrders(); // Initial call for confirmed orders
    }, 10000); // Refresh every 10 seconds
  }


getAllOrder() {
  this.orderService.getOrderCount().subscribe(
    (res: any) => {
      // const pendingOrders = res.filter(order => order.status === 'Pending');
    //  const confirmedOrders = res.filter(order => order.status === 'Confirmed');

      const newPendingCount = res.pendingCount;
      this.confirmOrderId = res.confirmOrderId;
     // const newConfirmedCount = confirmedOrders.length;

      // Always update the UI with latest counts
      this.pendingCount = newPendingCount;
     // this.confirmedCount = newConfirmedCount;

      // Detect if new orders arrived (only notify if increased)
      const pendingDiff = newPendingCount - this.previousPendingCount;
     // const confirmedDiff = newConfirmedCount - this.previousConfirmedCount;

      let messageParts: string[] = [];

      if (pendingDiff > 0) {
        messageParts.push(`🔔 <strong>${pendingDiff}</strong> new <strong>Pending</strong> orders`);
      }

    //   if (confirmedDiff > 0) {
    //     messageParts.push(`✅ <strong>${confirmedDiff}</strong> new <strong>Confirmed</strong> orders`);
    //   }

      if (messageParts.length > 0) {
        this.pendingNotificationMessage = messageParts.join(' & ') + ' received!';
        setTimeout(() => {
            this.pendingNotificationMessage = '';
        },5000); // Hide notification after 5 seconds
      }

      // Store current counts as previous for next check
      this.previousPendingCount = newPendingCount;
     // this.previousConfirmedCount = newConfirmedCount;
     
      this.cdr.detectChanges();
    },
    (err: any) => {
      console.error('Error fetching orders:', err);
    }
  );
}

  
getConfirmedOrders() {
    // Fetch JSS data first
    this.jss.getJssNotificationCount().subscribe(
        (jssList: any[]) => {
            // const jssCreatedIds = jssList;
            const jssCreatedIds = new Set( jssList.map(jss => jss.id) );
            
            this.orderList = this.confirmOrderId.filter(order => !jssCreatedIds.has(order._id));

            this.filteredOrderList = [...this.orderList];
            
            const newConfirmedCount = this.filteredOrderList.length;

            let messageParts: string[] = [];
            if (newConfirmedCount > this.previousConfirmedCount) {
                messageParts.push(`✅ <strong>${newConfirmedCount - this.previousConfirmedCount}</strong> new <strong>Confirmed</strong> orders`);
            }
            this.confirmedCount = newConfirmedCount;
            if (messageParts.length > 0) {
                this.confirmedNotificationMessage = messageParts.join(' & ') + ' received!';
                setTimeout(() => {
                    this.confirmedNotificationMessage = '';
                }, 5000); // Hide notification after 5 seconds
              }
            this.previousConfirmedCount = newConfirmedCount;
            this.cdr.detectChanges(); // Trigger change detection
        },
        (err: any) => {
            console.log(err);
        }
    );
}
  
  logOut(){
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  // refreshPage() {
  //   // Get the current route
  //   const currentUrl = this.router.url;

  //   // Navigate to the same route to refresh it
  //   this.router.navigateByUrl('/blank', { skipLocationChange: true }).then(() => {
  //     this.router.navigate([currentUrl]);
  //   });
  // }
  
  // refreshPage(): void {
  //   window.location.reload();
  // }

  // refreshPage() {
  //   console.log('Button clicked'); // Add this log to check if the method is called
  
  //   const currentUrl = this.router.url;
  //   console.log('Current URL:', currentUrl);
  
  //   // Reload the page in the same URL location
  //   window.location.reload();
  
  //   console.log('Page should now reload at the same location.');
  // }
  refreshPage() {
    console.log('Button clicked'); // Check if method is triggered
    const currentUrl = this.router.url;
    console.log('Current URL:', currentUrl);
  
    // Use setTimeout to delay the reload slightly
    setTimeout(() => {
      window.location.reload();
      console.log('Page should now reload at the same location.');
    }, 500);  // Delay by 500ms or adjust as necessary
  }
  
  


  // just a console version of above first one
//   refreshPage() {
//     // Get the current route
//     const currentUrl = this.router.url;

//     console.log('Current URL:', currentUrl);  // Log the current URL

//     // Navigate to a temporary route to trigger a route change without changing the URL
//     console.log('Navigating to a temporary route...');
//     this.router.navigateByUrl('/blank', { skipLocationChange: true }).then(() => {
//         console.log('Navigated to /blank, now navigating back to original URL...');
        
//         // Now navigate back to the current URL to refresh the route
//         this.router.navigate([currentUrl]).then(() => {
//             console.log('Page refreshed, navigated back to:', currentUrl);
//         }).catch((err) => {
//             console.error('Error navigating back to the original URL:', err);
//         });
//     }).catch((err) => {
//         console.error('Error navigating to /blank route:', err);
//     });
// }



  dropdownOpen: boolean = false;
  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;
  
    if (this.dropdownOpen) {
      this.getAllOrder();  // Fetch fresh data when dropdown opens
    }
  }
  
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    this.dropdownOpen = false;
  }
}

